import { render, staticRenderFns } from "./EditEventOwner.vue?vue&type=template&id=338121ce&scoped=true&"
import script from "./EditEventOwner.vue?vue&type=script&lang=js&"
export * from "./EditEventOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338121ce",
  null
  
)

export default component.exports